const mediaItems = [
  {
    title: '七月新番追更指南',
    desc: '本季最值得追的连载漫画全盘点，从热血到悬疑一网打尽，帮你锁定追更清单',
    tag: '新番导航',
    duration: '15分钟阅读',
    views: '12.6万',
    img: 'https://readdy.ai/api/search-image?query=Vibrant%20flat%20design%20illustration%20of%20colorful%20manga%20magazine%20covers%20floating%20in%20dynamic%20arrangement%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20comic%20page%20elements%2C%20modern%20clean%20background%2C%20energetic%20composition%2C%20artistic%20style%2C%20soft%20lighting&width=800&height=500&seq=manwa-media-1&orientation=landscape',
  },
  {
    title: '国漫精品深度评测',
    desc: '从分镜到剧情，带你细品近年国产漫画的惊艳之作，每一部都值得加入追更列表',
    tag: '深度漫评',
    duration: '20分钟阅读',
    views: '9.8万',
    img: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20design%20of%20Chinese%20ink%20style%20comic%20panels%20blended%20with%20modern%20digital%20art%2C%20warm%20amber%20and%20coral%20accents%2C%20clean%20background%2C%20artistic%20illustration%20style%2C%20soft%20atmospheric%20lighting%2C%20creative%20composition&width=800&height=500&seq=manwa-media-2&orientation=landscape',
  },
  {
    title: '追更效率提升攻略',
    desc: '如何高效管理你的追更列表？漫蛙追更助手全功能介绍与使用技巧分享',
    tag: '使用教程',
    duration: '10分钟阅读',
    views: '8.3万',
    img: 'https://readdy.ai/api/search-image?query=Modern%20flat%20design%20illustration%20of%20organized%20digital%20reading%20list%20with%20manga%20thumbnails%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20clean%20minimal%20background%2C%20tech%20friendly%20vibe%2C%20artistic%20style%2C%20soft%20lighting%2C%20creative%20layout&width=800&height=500&seq=manwa-media-3&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
            精选漫评
          </h2>
          <p className="text-foreground-600 text-base md:text-lg max-w-2xl mx-auto">
            编辑团队精心挑选的漫画追更深度内容，帮你发现更多好漫画
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {mediaItems.map((item, i) => (
            <a key={i} href="#media" className="group block rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden cursor-pointer transition-all duration-300 hover:border-primary-200">
              <div className="relative overflow-hidden">
                <div className="w-full aspect-[16/10] overflow-hidden">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1.5 bg-primary-500 text-white text-xs font-semibold rounded-full">{item.tag}</span>
                </div>
                <div className="absolute bottom-4 right-4">
                  <span className="px-3 py-1.5 bg-black/60 backdrop-blur-sm text-white text-xs rounded-full">{item.duration}</span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-lg font-semibold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">{item.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed mb-3 line-clamp-2">{item.desc}</p>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span className="flex items-center gap-1"><i className="ri-eye-line"></i>{item.views} 阅读</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}